
import { defineComponent, ref, reactive, watch, nextTick, onMounted, onBeforeUnmount, getCurrentInstance } from 'vue'

export default defineComponent({
    setup (props, context) {
        const isShow = ref<boolean>(true)

        const hide = () => {
            isShow.value = false
        }

        onMounted(() => {
            isShow.value = !localStorage.getItem('GUIDEMASKHIDE')
            localStorage.setItem('GUIDEMASKHIDE', '1')
        })    

        return {
            isShow,
            hide
        }
    }
})
